import React, { useRef, useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { setLocale } from 'yup';
import { SuccessMessage, ErrorMessage } from '../../../../extras/toastMessages';
import clienteAxios from '../../../../../config/axios';
import { MSG_REJECT_SUCCESS, MSG_UPDATE_SUCCESS } from '../../../../../constants/messages';
import { ICON_SAVE, ICON_CANCEL } from '../../../../extras/icons';
import ButtonSpinner from '../../../../layout/ButtonSpinner'
import { FUNC_FISCAL } from '../../../../../data/functionaryTypes';
import { FISCALIA } from '../../../../../data/jurisdictions';
//Redux
import { useDispatch } from 'react-redux';
import { updateProsecutorAction } from '../../../../../actions/audiencesActions';
//Función principal
const ProsecutorEditForm = props => {
    //Tomo los props
    const { show, handleClose, audience } = props;
    //Genero los ref
    const refProsecutorOffice = useRef();
    //Inicializo datos
    const initialData = {
        fiscal: audience && audience.fiscal ? audience.fiscal.id : '',
        fiscalia: audience && audience.fiscalia ? audience.fiscalia.id : ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Inicializo el state local
    const [loading, setLoading] = useState(false);
    const [prosecutors, setProsecutors] = useState([]);
    const [prosecutorOffices, setProsecutorOffices] = useState([]);
    //Manejo cuando se muestra
    const handleOnShow = e => {
        //Cargo los motivos
        loadParameters();
        //Pongo el foco en el primer campo
        refProsecutorOffice.current.focus();
    }
    //Manejo el guardado
    const handleSave = async values => {
        //Armo los datos
        const data = {
            fiscalId: values.fiscal,
            fiscaliaId: values.fiscalia
        }
        //Llamo al dispatch
        dispatch( updateProsecutorAction(audience, data, handleClose) );
    }
    //Función que cargar los parámetros
    const loadParameters = async () => {
        try{
            //Fiscalia
            const responseProsecutorOffices = await clienteAxios.get(`/unidad?search=activo:1,perfil.id:${FISCALIA}&sort=descripcion:asc`);
            setProsecutorOffices(responseProsecutorOffices.data.content);
            //Fiscal
            const responseProsecutors = await clienteAxios.get(`/funcionario?search=tipo.id:${FUNC_FISCAL}&sort=apellido:asc&sort=nombre:asc`);
            //Seteo los datos
            setProsecutors(responseProsecutors.data.content);

        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
    //Esquema de validación
    const validationSchema = yup.object({
        fiscalia: yup.number().required(),
        fiscal: yup.number().required(),
    });
    //Renderizo
    return (
        <Modal
            show={show} 
            onHide={handleClose} 
            onShow={handleOnShow} 
            aria-labelledby="contained-modal-title-vcenter" 
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Editar Fiscalía/Fiscal <small>(Audiencia #{ audience && audience.id })</small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema={validationSchema}
                initialValues={{ ...initialData }}
                onSubmit={ values => handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        Puede modificar los siguientes datos
                                    </div>
                                </div>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        as="select"
                                        id="fiscalia"
                                        className="form-control"  
                                        name="fiscalia" 
                                        type="text" 
                                        value={ values.fiscalia }
                                        onChange={handleChange}
                                        ref={refProsecutorOffice}
                                        isInvalid={!!errors.fiscalia}
                                        disabled={ loading }
                                    >
                                        <option value="">Seleccione Fiscalía...</option>
                                        {
                                            prosecutorOffices.map(po => (
                                                <option value={ po.id } key={`pefpo${po.id}`}>
                                                    { po.descripcion }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.fiscalia }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <Form.Control
                                        as="select"
                                        id="fiscal"
                                        className="form-control"  
                                        name="fiscal" 
                                        type="text" 
                                        value={ values.fiscal }
                                        onChange={handleChange}
                                        isInvalid={!!errors.fiscal}
                                        disabled={ loading }
                                    >
                                        <option value="">Seleccion Fiscal...</option>
                                        {
                                            prosecutors.map(p => (
                                                <option value={ p.id } key={`pefp${p.id}`}>
                                                    { p.apellido + ', ' + p.nombre }
                                                </option>
                                            ))
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.fiscal }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {
                                loading ? (
                                    <ButtonSpinner />
                                ) : (
                                    <Button variant="success" type="submit" disabled={ loading }>
                                        <ICON_SAVE /> <strong>ACTUALIZAR</strong>
                                    </Button>
                                )
                            }
                            <Button variant="secondary" onClick={handleClose} disabled={ loading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default ProsecutorEditForm;